import React, { useRef } from "react";

export function VerifyOtpForm(props) {
	const instanceRef = useRef({ props });
	instanceRef.current.props = props;
	initialConstruct.bind(instanceRef.current)("VerifyOtpForm", props);

	const { submit, setState: setParent, formref, store } = props;
	const otpref = useRef();

	const handlenext = (event) => {
		if (event.target.value.length === 1) {
			const form = event.target.form;
			const index = [...form].indexOf(event.target);
			form.elements[index + 1].focus();
			event.preventDefault();
		}
	};

	const setInput = (value, index) => {
		let otp = otpref.current.value.padEnd(4, '0').split('').slice(0, 4);
		otp[index] = value;
		otpref.current.value = otp.join('');
	};

	return (
		<form
			ref={formref}
			className="popuplogin"
			onSubmit={(e) => submit(e)}
		>
			<div className='title'>Verify your email</div>
			<div className='des'>Please fill the verification code We sent you in your email</div>
			<div className='form-input'>
				<input type='hidden' name="otp" ref={otpref}></input>
				<input type='text' className='input-small' maxlength="1" onKeyUp={handlenext} pattern="[0-9]" required onChange={(e) => {
					setInput(e.target.value, 0)
				}} />
				<input type='text' className='input-small' maxlength="1" onKeyUp={handlenext} pattern="[0-9]" required onChange={(e) => {
					setInput(e.target.value, 1)
				}} />
				<input type='text' className='input-small' maxlength="1" onKeyUp={handlenext} pattern="[0-9]" required onChange={(e) => {
					setInput(e.target.value, 2)
				}} />
				<input type='text' className='input-small' maxlength="1" onKeyUp={handlenext} pattern="[0-9]" required onChange={(e) => {
					setInput(e.target.value, 3)
				}} />
			</div>
			<div className="form-input forgetpassword">
				<label
					className="label"
					onClick={() => setParent({ form: "login" })}
				>
					Sign In
				</label>
			</div>
			<div className="form-input">
				<span style={{ fontWeight: "bold", color: "red", fontSize: "10px" }}>
					{store.errorMsg}<br/>{store.failureMsg}
				</span>
			</div>
			<div className="form-input">
				<button type="submit" className="button" id="verify">
					Verify
				</button>
			</div>
		</form>
	);
}

export default VerifyOtpForm;
